module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av159-38d5666e51e763327e40ea69be43f80c.jpg";